
export default  [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'id_par',
        label: 'Copiar Tabela de Preço',
        placeholder: 'Selecione o parceiro...',
        clearable: true,
        info: 'Você pode copiar uma tabela de preço de outro parceiro. Escolha aqui o parceiro que deseja utilizar como modelo que o sistema vai duplicar a base de exames.',
        option: {
            label: 'nome',
            value: 'id'
        },
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'id_exa',
        label: 'Exame',
        option: {
            label: 'nome',
            value: 'id'
        },
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'text',
        field: 'parceiro_padrao',
        label: 'Parceiro Padrão',
        info: '',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'text',
        field: 'valor_custo',
        label: 'Valor de Custo',
        mask: 'money',
        info: '',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
        type: 'text',
        field: 'valor_venda',
        label: 'Valor de Venda',
        mask: 'money',
        info: '',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4',
        type: 'boolean',
        field: 'padrao',
        label: 'Definir esse Parceiro como Padrão',
        info: 'Aqui você pode habilitar esse parceiro como padrão para esse exame.',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8',
        type: 'boolean',
        field: 'atualizar_tb_empresa',
        label: 'Atualizar Tabela de Preço das Empresas',
        info: 'Se habilitar essa opção o sistema vai inserir na tabela de preço das empresas, caso não existir, esse parceiro como padrão para esse exame. Se existir esse parceiro cadastrado o sistema vai apenas definir o exame como esse parceiro padrão.',
        rules: ['']
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/web/parceiro/_form/parceiro-exame-cadastrar.js